import { type EntityModel } from "@doitintl/cmp-models";
import { type ModelIdRef } from "@doitintl/models-any";
import { type AutocompleteRenderInputParams, CircularProgress } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { type TextFieldProps } from "@mui/material/TextField/TextField";

type Value = ModelIdRef<EntityModel>;

type EntitySelectProps = {
  value: Value | undefined | null;
  loading?: boolean;
  options: Value[];
  setFieldValue: (field: "entity", value: Value | null) => void;
  getOptionLabel?: (option: Value) => string;
  getOptionDisabled?: (option: Value) => boolean;
  TextFieldProps?: TextFieldProps;
};

const EntitySelect = ({
  value,
  setFieldValue,
  options,
  loading,
  getOptionLabel = (entity) => `${entity.priorityId} - ${entity.name}`,
  getOptionDisabled,
  TextFieldProps,
}: EntitySelectProps) => (
  <Autocomplete<Value>
    getOptionLabel={getOptionLabel}
    options={options}
    loading={loading}
    value={value}
    isOptionEqualToValue={(option, value) => option.id === value?.id}
    getOptionDisabled={getOptionDisabled}
    onChange={(_event, newValue) => {
      setFieldValue("entity", newValue);
    }}
    renderInput={(params: AutocompleteRenderInputParams) => (
      <TextField
        {...params}
        name="entity"
        label="Billing Profile"
        variant="outlined"
        margin="dense"
        {...TextFieldProps}
        slotProps={{
          input: {
            ...params.InputProps,
            ...TextFieldProps?.slotProps?.input,
            "data-cy": "entity-select",
            endAdornment: (
              <>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          } as any,

          inputLabel: { shrink: true },
        }}
      />
    )}
  />
);

export default EntitySelect;
